import React from 'react';

import Zoom from 'assets/images/icon/Zoom';
import dayjs from 'dayjs';
import { cloneDeep } from 'lodash';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { textTransform } from 'util/textTransform';
import DeleteIcon from "../../../../assets/images/icon/DeleteIcon";
import ClockIcon from "../../../../assets/images/icon/ClockIcon";
import TrashCanDark from "../../../../assets/images/icon/TrashCanDark";
import {dateUtil, isEmpty} from "../../../../util";
import {fadeIn} from "../../../../styled/StyledComponent";
import ListButtonItem from "../../../components/common/ListButtonItem";

const returnColor = (text) => {
    switch (text) {
        case "New": {
            return "#FFC8DD";
        }
        case "IN_PROGRESS": {
            return "#9AE3B7";
        }
        case "RECEIVED": {
            return "#B0CBFF";
        }
        case "DRAFT": {
                return "#F0A8A8";
        }
        case "PUBLISHED":{
                return "#B0CBFF"
        }
        default:
            break;
    }
};
const ListItem = (props) => {
    const navigate = useNavigate();

    const onClickEdit = (progress) => {
        switch (progress){
            case "DRAFT" : {
                return {
                    icon:<TrashCanDark/>,
                    event:() => {props?.onClickIcon(props?.data?.id)}
                }
            }
            case "IN_PROGRESS"  : {
                return {
                    // icon:<ClockIcon/>,
                    // event:() => {
                    //     props?.onClickSelect(props?.data)
                    //     props?.onClickTimePopup();
                    // }
                    icon:<TrashCanDark/>,
                    event:() => {props?.onClickIcon(props?.data?.id)}
                }
            }
            case "PUBLISHED" : {
                return {
                    icon:<ClockIcon/>,
                    event:() => {
                        props?.onClickSelect(props?.data)
                        props?.onClickTimePopup();
                    }
                }
            }
            default : {
                return {
                    icon:<TrashCanDark/>,
                    event:() => {}
                }
            }
        }
    }
    const returnData = (date) => {
        // const c = cloneDeep(date)?.map((item, index) => {
        //     if (index === 1) {
        //         item = item - 1;
        //     }
        //     return item;
        // });
        // let ms = dayjs(Date.UTC.apply(null, c?.slice(0, 6)))
        //     .utc()
        //     .locale("en")
        //     .format("MMM DD, YYYY");
        return date;
    };

    const checkTimeAway = () => {
        if(props?.data?.progress !== "PUBLISHED") return false
        if(isEmpty(props?.data?.coachingTypes)) return false
        const c = cloneDeep(props?.data);
        const check = c?.coachingTypes?.findIndex(item => {
            return item?.timeAway === true
        })

        if(check !== -1){
            return true
        }else{
            return false
        }
    }
    console.log('listData', props?.data)
    // @ts-ignore
    return (
        <Container>       
            <Thumb>
                <img src={props?.data?.thumbnail?.url ?? "/images/homeworkImg.png"} alt="" />
                <EditIcon className={"edit"}
                    onClick={()=>{
                        onClickEdit(String(props?.data?.progress))?.event()
                    }}
                >
                    {onClickEdit(String(props?.data?.progress))?.icon}
                </EditIcon>
                <ClassInfo>
                    <span>
                        {props?.classTitle}
                    </span>
                </ClassInfo>
            </Thumb>
            <ListMain>
                <CategoryList>
                    <div className="categories">
                        <Category
                            style={{
                                background: returnColor(String(props?.data?.progress)),
                            }}
                        >
                        <span>{textTransform().capitalizeFirstLetter(String(props?.data?.progress)?.toLocaleLowerCase()) === "In_progress" ? "Submitted" :
                            textTransform().capitalizeFirstLetter(String(props?.data?.progress)?.toLocaleLowerCase())}</span>
                        </Category>
                        {
                            checkTimeAway() === true &&
                            <Category
                                onClick={()=>{
                                    props?.onClickSelect(props?.data)
                                    props?.onClickTimePopup(props?.data);
                                }}
                                style={{
                                    background: "#CDB4DB",
                                    cursor:"pointer"
                                }}
                            >
                                <span>Time Away</span>
                            </Category>
                        }

                    </div>

                    <ListButton
                        className={"mobileBtn"}
                        onClick={()=>{
                        // props.onClickPopup(props?.data)
                        navigate("/create_coaching/details", {
                            state:{
                                createId:props?.data?.id
                            }
                        })
                    }}>
                        <span>{props?.data?.progress !== "DRAFT" ? "View" : "Edit"}</span>
                        {props?.data?.progress !== "DRAFT" ? (
                            <Zoom />
                        ) : (
                            <img src={"/images/pen.png"} alt="" />
                        )}
                    </ListButton>
                </CategoryList>
                    <h3>
                    {props?.data?.title || "How to Enhance Your Entrepreneurship"}
                    </h3>
                <DateItem style={{ marginBottom: 0 }}>
                    <p className={"date"}>
                        {dateUtil.mainCardDateFormat(props?.data?.updatedDatetime || "2024-12-01")}
                    </p>
                </DateItem>
            </ListMain>

            <ListButton onClick={()=>{
                // props.onClickPopup(props?.data)
                navigate("/create_coaching/details", {
                    state:{
                        createId:props?.data?.id
                    }
                })
                }}>
                <span>{props?.data?.progress !== "DRAFT" ? "View" : "Edit"}</span>
                {props?.data?.progress !== "DRAFT" ? (
                    <Zoom />
                ) : (
                    <svg width="14" height="14" viewBox="0 0 18 18" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M13.6648 0.164752C13.8844 -0.0549174 14.2406 -0.0549174 14.4602 0.164752L17.8352 3.53975C18.0549 3.75942 18.0549 4.11557 17.8352 4.33524L6.58526 15.5852C6.53139 15.6391 6.46715 15.6815 6.39642 15.7098L0.771423 17.9598C0.562501 18.0433 0.323879 17.9943 0.164769 17.8352C0.00565862 17.6761 -0.0433205 17.4375 0.0402482 17.2286L2.29025 11.6036C2.31854 11.5329 2.3609 11.4686 2.41477 11.4147L13.6648 0.164752ZM12.608 2.8125L15.1875 5.392L16.642 3.9375L14.0625 1.35799L12.608 2.8125ZM14.392 6.18749L11.8125 3.60799L4.50001 10.9205V11.25H5.06251C5.37317 11.25 5.62501 11.5018 5.62501 11.8125V12.375H6.18751C6.49817 12.375 6.75001 12.6268 6.75001 12.9375V13.5H7.07951L14.392 6.18749ZM3.41062 12.0099L3.2919 12.1286L1.57223 16.4278L5.8714 14.7081L5.99012 14.5894C5.77683 14.5094 5.62501 14.3037 5.62501 14.0625V13.5H5.06251C4.75185 13.5 4.50001 13.2481 4.50001 12.9375V12.375H3.93751C3.69631 12.375 3.49056 12.2232 3.41062 12.0099Z"
                            fill="#333333"
                        />
                    </svg>
                )}
            </ListButton>
        </Container>
    );
};
export default ListItem;

const ContentsInner = styled.div`
    padding: 20px;
    overflow: hidden;
`;

const Wrap = styled.div`
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;

    &::-webkit-scrollbar {
        width: 0;
    }

    &::-webkit-scrollbar-thumb {
        background-color: transparent;
    }
`;

const Container = styled.div`
    display: flex;
    position: relative;
    padding: 20px 0;
    border-top: 1px solid rgba(51, 51, 51, 0.3);

    .edit {
        transition: all 0.2s;
        opacity: 0;
        pointer-events: none;
    }

        //animation: ${fadeIn} 0.3s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */

    &:hover {
        .edit {
            opacity: 1;
            pointer-events: all;
        }
    }
`;
const Thumb = styled.div`
    transition: all 0.2s;
    background: #ddd;
    width: 113px;
    height: 113px;
    border-radius: 5px;
    position: relative;

    img {
        display: block;
        border-radius: 5px;
        height: 100%;
        width: 100%;
        object-fit: cover;
    }

`;
const EditIcon = styled.div`
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        pointer-events: none;
    }

    cursor: pointer;
    width: 30px;
    height: 30px;
    transform: translate(-25%, -25%);
    border-radius: 50%;
    background: #fff;
   position: absolute;
    box-shadow: -1px 1px 4px 0px #3333331F;
`
const ClassInfo = styled.div`
    position: absolute;
    border-radius: 0 0 5px 5px;
    z-index: 9;
    width: 100%;
    padding-top: 7px;
    padding-bottom: 6px;
    display: flex;
    justify-content: center;
    background: #333;
    padding-left: 10px;
    padding-right: 10px%;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    left: 0;
    bottom: 0;
    span{
        font-family: Europa-Regular;
        font-size: 12px;
        font-weight: 400;
        line-height: 12px;
        letter-spacing: 0em;
        text-align: left;
        color: #fff;
    }
`
const ListMain = styled.div`
    padding: 0 20px;
    flex: 1;
    display: flex;
    flex-direction: column;
    //justify-content: space-between;
    @media screen and (max-width: 768px) {
        padding-right: 0!important;
    }
    h3 {
        font-weight: 700;
        line-height: 26px;
        font-size: 26px;
        margin: 0px 0 9.6px 0;
        @media screen and (max-width: 768px) {
            
          font-size: 20px;
        }
    }
`;
const CategoryList = styled.div`
    .categories{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }
    width: 100%;
    align-items: center;
    justify-content: space-between;

    display: flex;
    flex-wrap: wrap;
`;
const Category = styled.div`
    padding: 7px 0px;
    margin-right: 15px;
    background: #f0a8a8;
    cursor: default;
    width: 85px;
    font-size: 12px;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    margin-bottom: 4px;
    font-weight: 700;
    span {
        text-transform: capitalize;
    }
`;
const DateItem = styled.div`
    display: flex;
    p {
        &.date{
            font-family: "Source Serif 4", sans-serif;
        }
        color: #333333;
        font-size: 14px;
        font-weight: 600;
        line-height: 14px;
        letter-spacing: 0em;
        text-align: left;
        opacity: 0.5;
    }
    span {
        font-size: 14px;
        font-weight: 600;
        line-height: 14px;
        letter-spacing: 0em;
        text-align: left;
        color: #333333ac;
    }
`;

const Progress = styled.div`
    font-size: 14px;
    font-weight: 700;
    line-height: 14px;
    letter-spacing: 0em;
    color: rgba(51, 51, 51, 0.6);
    text-align: end;
    margin-bottom: 0.25rem;
    max-width: 500px;
    b {
        color: #333;
    }
`;
const ProgressBar = styled.div``;
const ListButton = styled.div`
    transition: all 0.2s;
    border: solid 1px #333;
    &:hover{
        background: #fff;
        span{
            color: #333;
        }
        svg{
            display: block;
            path{
                fill: #333;
            }
        }
    }
    svg{
        display: block;
        path{
            fill: #fff;
        }
    }
    &.mobileBtn{
        height: 26px;
        margin-bottom: 4px;
        display: none;
        @media screen and (max-width: 768px) {
            display: flex;
        }
    }
    @media screen and (max-width: 768px) {
        //position: absolute;
        display: none;
    }
    min-width: 87px;
    background: #333;
    width: 87px;
    height: 26px;
    border-radius: 5px;
    overflow: hidden;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    span {
        padding-top: 2px;
        margin-right: 10px;
        display: flex;
        height: 100%;
        align-items: center;
        color: #fff;
        box-shadow: none;
        border-radius: 5px;
        font-family: var(--fontFamilyRegular);
        font-size: 12px;
        font-weight: 400;
        line-height: 12px;
    }
`;

const Instructor = styled.div`
    margin-left: 20px;
`;
const User = styled.div`
    font-size: 16px;
    font-weight: 700;
    color: #333333d2;
`;
